module.exports = __webpack_public_path__ + "media/icons/plyny-eksploatacyjne-title-blue@3x-f75442c7.svg";